export default __webpack_public_path__ + "static/media/about-shape.1935a6be.svg";